module.exports = __webpack_public_path__ + "img/pricing-tree-3.345769a0.png";